import { GameId, ProductContent } from '@common'

import { BrawlItem } from './Brawl'
import { ClashItem } from './Clash'
import { RoyaleItem } from './Royale'
import { SquadItem } from './Squad'

type Props = {
  gameId: GameId
  content: ProductContent
}

export const Item = ({ gameId, content }: Props) => {
  switch (gameId) {
    case 'clashofclans':
      return <ClashItem content={content} />
    case 'brawlstars':
      return <BrawlItem content={content} />
    case 'clashroyale':
      return <RoyaleItem content={content} />
    case 'squadbusters':
      return <SquadItem content={content} />
    default:
      return null
  }
}
